<template lang="pug">
div.map-app__tabs-container
    ul.map-app__tabs
        .tab-border-top(
            :class="`${activeTab} ${isMoving ? 'is-moving':''}`"
        )
        li: router-link(
            to="/highlight"
            id="highlight"
            @click.native="tabSelected('highlight' ,$event)"
            :class="activeTab == 'highlight' ? 'active' : ''"
        ) highlights
        li: router-link(
            to="/about"
            id="about"
            @click.native="tabSelected('about' ,$event)"
            :class="activeTab == 'about' ? 'active' : ''"
        ) about
    .map-app__info-col-content
        slot
</template>
<script>

export default {
    data() {
        return {
            activeTab: 'highlight',
            isMoving: false,
        }
    },
    mounted() {
        this.activeTab = /highlight/.test(this.$route.path) ? 'highlight' : '';
    },
    methods: {
        tabSelected(elName, e) {
            e.preventDefault()
            this.activeTab = elName
        }
    },
    watch: {
        activeTab() {
            this.$emit('tab-selected', this.activeTab)
            this.isMoving = true
            setTimeout(() => {
                this.isMoving = false
            }, 1870)
        },
        $route() {
            if (/highlight/.test(this.$route.path)) {
                this.activeTab = 'highlight'
            } else if(/about/.test(this.$route.path)) {
                this.activeTab = 'about'
            }
        }
    }
}
</script>
<style lang="scss">
@import "../scss/variables";

.tab-border-top {
    position: absolute;
    width: calc(50% + 1px);
    height: 4px;
    content: '';
    background-color: $red;
    top: -4px;
    left: 0;
    transition: transform 0.187s ease-in-out;
    transform: translateX(0);
    // animation: fade-in 0.187s ease-in-out 0s infinite normal none paused;
    pointer-events: none;
    opacity: 1;

    &.about {
        transform: translateX(calc(100% - 2px));
    }

    &.is-moving {
        // animation: fade-in 0.187s ease-in-out 0s 1 normal none running;
    }
}

@keyframes fade-in {
  0% {
    opacity: 1;
  }
  /* Adding a step in the middle */
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.map-app__tabs {
    position: relative;
    display: flex;
    flex-direction: row;
    list-style: none;
    text-decoration: none;
    margin-bottom: 2rem;

    li {
        width: 50%;
    
        a {
            position: relative;
            display: block;
            width: 100%;
            font-family: 'open_sansbold', Arial;
            padding: 1rem;
            text-align: center;
            background: $grey1;
            color: $black;
            text-transform: capitalize;
            border: 1px solid $grey2;
            cursor: pointer;
            transition: background-color 0.25s linear;

            // &::after {
            //     position: absolute;
            //     width: calc(100% + 2px);
            //     height: 0;
            //     content: '';
            //     background-color: transparent;
            //     top: -4px;
            //     left: -1px;
            //     transition: background-color 0.25s;
            // }

            &.active {
                background: $white;
                border: 1px solid transparent;

                // &::after {
                //     background-color: $red;
                //     height: 4px;
                // }
            }
        }
    }
}

</style>